export const initGA = () => {
  const GA_ID = process.env.REACT_APP_GA_ID;

  if (!GA_ID) return;

  // Load gtag script
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Init gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_ID);
};

export const trackPageView = (path) => {
  if (!window.gtag) return;

  window.gtag("config", process.env.REACT_APP_GA_ID, {
    page_path: path,
  });
};
